import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { Flex, Text } from "@chakra-ui/react";

export default function SplashScreenLayout({ children }) {
  const [authLoaded, setAuthLoaded] = useState(false);
  const [delayLoaded, setDelayLoaded] = useState(false);
  const [splashScreenEnabled, setSplashScreenEnabled] = useState(true);
  auth.onAuthStateChanged(() => {
    setAuthLoaded(true);
  });

  useEffect(() => {
    setTimeout(() => {
      setDelayLoaded(true);
    }, 2000);
  }, []);

  const loaded = authLoaded && delayLoaded;

  useEffect(() => {
    if (loaded) {
      setTimeout(() => {
        setSplashScreenEnabled(false);
      }, 1000);
    }
  }, [loaded]);

  return (
    <>
      {splashScreenEnabled && (
        <Flex
          className={loaded ? "animate__animated animate__fadeOutLeft" : ""}
          position={"fixed"}
          top={0}
          left={0}
          width={"full"}
          height={"100%"}
          backgroundImage={`url("/images/splash.jpg")`}
          backgroundSize={"cover"}
          backgroundPosition={"center"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Text
            className="animate__animated animate__fadeInUp"
            fontSize={"xs"}
            fontWeight={"bold"}
            color={"white"}
          >
            Made by FloatFlower
          </Text>
        </Flex>
      )}
      {!splashScreenEnabled && children}
    </>
  );
}
